import { connect } from 'react-redux'
import requestChangeLabelName from '../../../sagas/requestChangeLabelName'
import requestChangeLabelColor from '../../../sagas/requestChangeLabelColor'
import EditLabel from './EditLabel'

export default connect(
  null,
  {
    requestChangeLabelName,
    requestChangeLabelColor
  }
)(EditLabel)
